"use client"

import * as React from "react"
import { TrackJS } from "trackjs-nextjs"

// IMPORTANT: THIS IS A TEMPORARY PAGE! WE WIIL ADD THE REAL ERROR PAGE LATER
export default function GlobalError({ error }: { error: Error | Object | string }) {
  React.useEffect(() => {
    TrackJS.track(error)
  }, [error])

  return "TODO"
}
